import React, { useEffect, useRef, useState } from "react";
import {useLocation, useNavigate, useParams } from "react-router-dom";
import * as manualGuideService from "../../../../services/manual-guide.service";
import Loader from "../../../../common/loader";
import { formatDateFromTime, getTranslatedKey, handleServerValidations, TrimText } from "../../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../../../utils/Constants";
import { ReactSortable } from "react-sortablejs";
import RecordNotFound from "../../../../../restaurant/shared/recordNotFound";

// import $ from "jquery";

const ModulesList = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [loader, setLoader] = useState(false);
  const [list, setList] = useState([]);
  const [refresh , setRefresh]=useState(false);
  const location = useLocation();
  const [sortableData, setSortableData] = useState([]);
  const sortingCloseBtn = useRef();

  useEffect(() => {
    manualGuideService
      .moduleList({panel_id : params.id})
      .then((response) => {
        console.log("View response-", response);
        setList(response && response.data ? response.data.list : []);
        setSortableData(response && response.data ? response.data.list : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id , refresh]);

  const deleteModuleFunction = (id)=>{

    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#403fad',
      cancelButtonColor: '#f1388b',
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
  }).then((result) => {
      if (result.isConfirmed) {
          manualGuideService.deleteModule(id).then(response => {
              if (response.success) {
                  Swal.fire({
                      icon: 'success',
                      text: response.message,
                      ...SWAL_SETTINGS
                  });
                  setRefresh(!refresh)

              } else {
                  Swal.fire({
                      icon: 'error',
                      text: handleServerValidations(response),
                      ...SWAL_SETTINGS
                  })
              }
          }).catch(error => {
              console.log("deleteError");
          });
      }
  })

  };

  const handleAddImage = (module_id) => {
    const currentPath = location.pathname; 
    const newPath = currentPath.replace('/modules', `/modules-images/add/${module_id}`);
    navigate(newPath);
  };

  const handleViewImages =  (moduleId) => {
    navigate(`/admin/manual-guide/view/${params.id}/modules-images/${moduleId}`);
  };


  function handleSortCategories(closeModal = true) {
    manualGuideService.sortModuleList({ sorted_array: sortableData }).then((response) => {
      setRefresh(!refresh);
        if (response.success) {
            Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
            });
            if (closeModal) {
                sortingCloseBtn?.current?.click();
            }
          
        } else {
            Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
            });
        }
    }).catch((error) => {
        console.error("Error updating profile", error);
    });
}

//   function isSortingChanged(){
//     let changed = false;
//     let i = 0;
//     for (i; i < list.length; i++) {
//         if (list[i]?.order !== sortableData[i]?.order) {
//             changed = true;
//             break;
//         } else {
//             changed = false;
//         }
//     };
//     return changed;
// }

function isSortingChanged() {
  if (!Array.isArray(list) || !Array.isArray(sortableData)) return false;
  if (list.length !== sortableData.length) return true;

  for (let i = 0; i < list.length; i++) {
    const a = list[i];
    const b = sortableData[i];

    if (a?.order !== undefined && b?.order !== undefined) {
      if (a.order !== b.order) return true;
    } else {
      if (a?.title !== b?.title) return true;
    }
  }

  return false;
}


  const handleCloseSorting = () => {
    if (isSortingChanged()) {
        Swal.fire({
            title: t("question_to_save_data"),
            text: t("confirm_heading_found_unsaved_data_description"),
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#6c757d",
            cancelButtonColor: "#dc3545",
            confirmButtonText: t("btn_text_save_changes"),
            cancelButtonText: t("btn_text_discard"),
            customClass: {
                popup: 'swal-restaurant',
                confirmButton: 'btn btn-secondary col',
                cancelButton: 'btn btn-danger col'
            },
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                handleSortCategories(false);
            } else {
              setSortableData(list);
            }
        });
    }
};


  return (
    <>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body p-0">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="main-content-label">Modules </h6>

                <div className="d-flex align-items-center">
                  <button className="btn ripple btn-main-primary signbtn mx-2" data-bs-toggle="modal" data-bs-target="#sort-modal-module">
                    {t("label_sort")}
                  </button>

                  <button className="btn ripple btn-main-primary signbtn" onClick={() => navigate(`/admin/manual-guide/view/${params?.id}/modules/add`)}>
                    {t("btn_add_new")}
                  </button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                  <thead>
                    <tr>
                      <th className="position-relative select_head">
                        <span>{t("list_heading_sno")}</span>
                      </th>

                      <th>Title</th>
                      <th>title (Japanese)</th>
                      {/* <th>Slug</th> */}

                      <th className="action_head">{t("list_heading_action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <tr>
                        <td colSpan={10}>
                          <Loader />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {list.length ? (
                          list.map((row, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>

                                <td>{row?.title ? <div className="d-flex">{row?.title ? TrimText(row.title, 30) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                                <td>{row?.title_ja ? <div className="d-flex">{row?.title_ja ? TrimText(row.title_ja, 30) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                                {/* <td>{row?.slug ? <div className="d-flex">{row?.slug ? TrimText(row.slug, 30) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td> */}

                                <td>
                                  <div className="d-flex">
                                    <button
                                      className="btn ripple btn-main-primary signbtn mx-2"
                                      onClick={() => {
                                        handleViewImages(row._id);
                                      }}
                                    >
                                      View Images{" "}
                                    </button>

                                    <button
                                      className="btn ripple btn-main-primary signbtn"
                                      onClick={() => {
                                        handleAddImage(row._id);
                                      }}
                                    >
                                      Add Image
                                    </button>

                                    <button
                                      className="btn ripple btn-success mlAction"
                                      onClick={() => {
                                        navigate(`/admin/manual-guide/view/${params?.id}/modules/edit`, { state: { _id: row._id } });
                                      }}
                                    >
                                      {t("btn_edit")}
                                    </button>

                                    <button
                                      className="btn ripple btn-secondary mlAction"
                                      onClick={() => {
                                        deleteModuleFunction(row._id);
                                      }}
                                    >
                                      {t("btn_delete")}
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={10} className="text-center">
                              {t("msg_no_records")}
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade sort-modal-module" data-bs-backdrop="static" id="sort-modal-module" tabIndex="-1" aria-labelledby="sort-modalLabelModule" aria-hidden="true">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                  Sort Module
                </h1>
                <button type="button" className="btn-close btn-icon" onClick={handleCloseSorting} data-bs-dismiss="modal" aria-label="Close">
                  <i className="ti ti-x"></i>
                </button>
              </div>
              <div className="modal-body">
                {sortableData && sortableData.length ? (
                  <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Order Number</th>
                      <th>Title</th>
                      <th>Title (JA)</th>
                    </tr>
                  </thead>
                  <ReactSortable
                    tag="tbody"
                    list={sortableData}
                    setList={setSortableData}
                    ghostClass="dropArea"
                    handle=".dragHandle"
                    filter=".ignoreDrag"
                    preventOnFilter={true}
                  >
                    {sortableData.map((record, index) => (
                      <tr key={record.id || index}>
                         <td className="dragHandle">{record?.order ? record?.order : index+1}</td>
                        <td className="dragHandle">{TrimText(record.title, 30)}</td>
                        <td>{TrimText(record.title_ja , 30)}</td>
                      </tr>
                    ))}
                  </ReactSortable>
                </table>
                ) : (
                  <RecordNotFound heading="no_category_found_text" text="no_category_found_text_para" />
                )}
              </div>
              <div className="modal-footer justify-content-center">
                <button type="button" className="btn btn-danger me-2 d-none" data-bs-dismiss="modal" ref={sortingCloseBtn} aria-label="Close">
                  Close
                </button>
                <button type="button" className="btn ripple btn-main-primary signbtn" disabled={!isSortingChanged()} onClick={handleSortCategories}>
                  {t("btn_save_changes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModulesList;
